import { useContext } from 'react';
import { ConfigContext } from '../../context';

export const useIsPersonalizationEnabled = () =>
  useContext(ConfigContext).config.elements.newsFeed?.usePersonalization ?? false;
